import Gastos from './gastos.vue';
import GastoForm from './gasto-form.vue';
import GastoLote from './gasto-lote.vue';
import Error403 from '../403.vue';
import RoutesUtils from '../../js/RoutesUtils.js';
import { conUsuarioActualizado } from '../../js/barreraUsuarioActualizado.js';

// La pantalla es **para toda la plantilla**: cualquiera puede tener un gasto que justificar. El
// control de acceso de verdad es la entrada de menú (lote `fase-gastos-2026-10`, para todos los
// roles menos CLIENTE) y el backend, que devuelve a cada cual lo suyo y a ADMIN, ADMINISTRACION y
// DIRECTOR lo de cualquier persona. Esta lista solo decide mientras el menú no está cargado.
// Exportada para que quien enlace a /gastos/ desde fuera (la tarjeta del cuadro de mandos) haga
// exactamente la misma pregunta que la ruta, también en el repliegue sin menú.
export const ROLES = ['ADMIN', 'ENAC', 'PRODUCCION', 'INSPECTOR', 'INDUSTRIA', 'COMERCIAL', 'DTYCAL', 'FVYFP',
    'DIRECTOR', 'ADMINISTRACION', 'TRAMITACION', 'ENTREGA', 'ADMINISTRATIVO', 'PLANIFICADOR'];

/**
 * El permiso se decide con el usuario de ESTA carga (`conUsuarioActualizado`), no con el menú que
 * quedó en localStorage de la sesión anterior: en una recarga directa o un marcador, el menú viejo
 * dejaba en el 403 a quien acabaran de autorizar y montaba la pantalla a quien se lo hubieran
 * retirado (es la ventana que documenta `barreraUsuarioActualizado.js`). Mismo patrón que las
 * rutas de empleados y las del cuadro de mandos.
 */
function pantallaSiTieneAcceso(path, Comp, props) {
    return conUsuarioActualizado(function(routeTo) {
        if (!RoutesUtils.tieneAcceso(path, ROLES)) {
            return { component: Error403 };
        }
        return { component: Comp, props: props || {} };
    });
}

const routes = [
    {
        path: '/gastos/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: pantallaSiTieneAcceso('/gastos/', Gastos),
        keepAlive: true
    },
    {
        // Alta en lote: una foto con varios tickets, una línea por ticket (ver gasto-lote.vue).
        path: '/gastos/lote/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: pantallaSiTieneAcceso('/gastos/lote/', GastoLote)
    },
    {
        path: '/gastos/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: pantallaSiTieneAcceso('/gastos/new/', GastoForm)
    },
    {
        path: '/gastos/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: pantallaSiTieneAcceso('/gastos/edit/', GastoForm)
    },
    {
        path: '/gastos/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: pantallaSiTieneAcceso('/gastos/view/', GastoForm, { editable: false })
    }
];

export default routes;
